const tagFilter = document.querySelector('.js-tag-filter');
const catFilter = document.querySelector('.js-cat-filter');
const filterBtn = document.querySelector('.js-filter-posts');

var postFilters = {
  setSelectOption() {
    const searchParams = new URLSearchParams(window.location.search);

    // Log the values
    searchParams.forEach((value, key) => {
      if (key == 'tag_id') {
        if (Number.isInteger(parseInt(value))) {
          tagFilter.value = value;
          tagFilter.dispatchEvent(new Event('change'));
        }
      }

      if (key == 'cat') {
        if (Number.isInteger(parseInt(value))) {
          catFilter.value = value;
          catFilter.dispatchEvent(new Event('change'));
        }
      }
    });
  },
  init() {
    if (tagFilter && catFilter && filterBtn) {
      this.setSelectOption();


      $(filterBtn).on('click', function (e) {
        e.preventDefault();

        let tagValue = tagFilter.value;
        let catValue = catFilter.value;

        let redirectURL = '/news/';

        if (tagValue > 0 || catValue > 0) {
          redirectURL += '?';
        }

        if (tagValue > 0) {
          redirectURL += 'tag_id=' + tagValue;

          if (catValue > 0) {
            redirectURL += '&';
          }
        }

        if (catValue > 0) {
          redirectURL += 'cat=' + catValue;
        }

        console.log(redirectURL);

        window.location.href = redirectURL;
      });
    }
  },
};

export default postFilters;



// WEBPACK FOOTER //
// ./scripts/modules/post-filters.js